import React, { useState } from "react";
import { login } from "../../Actions/LoginAction";
import { useDispatch, useSelector } from "react-redux";
import {
  globalStyle,
  handleDangerVisible,
  validateEmail,
} from "../../global/Utils";
import { useNavigate } from "react-router-dom";
import ebeaconsoftsLogo from "../../Images/ebeaconsoftsLogo.png";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [helperText, setHelperText] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const isLoginUser = useSelector((state) => state.LoginReducer.isLoginUser);

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (validateEmail(value)) {
      setError(false);
      setHelperText("");
    } else {
      setError(true);
      setHelperText("Please enter a valid email address");
    }
  };

  const handleLogin = () => {
    dispatch(login({ email, password }, handleDangerVisible));
  };

  return (
    <div className="min-h-screen flex bg-[#F4F5F6]">
      {/* LEFT SIDE (Branding) */}
      <div className="hidden md:flex w-1/2 items-center justify-center bg-[#1a284f] text-white p-10">
        <div className="max-w-md text-center space-y-6">
          <div className="inline-block bg-white rounded-2xl px-6 py-4 shadow-lg">
            <img
              src={ebeaconsoftsLogo}
              alt="Ebeaconsofts"
              className="w-56 max-w-full"
            />
          </div>

          <h1
            className="text-3xl font-bold"
            style={{ fontFamily: globalStyle.fontFamilyHeading }}
          >
            Ebeaconsofts Digital Invoicing
          </h1>

          <p className="text-gray-300 text-sm leading-relaxed">
            Securely manage and submit your invoices to the Federal Board of
            Revenue. Designed for efficiency, compliance, and reliability.
          </p>

          <div className="pt-6 border-t border-white/20 text-sm text-gray-300">
            Powered by:{" "}
            <a
              href="https://ebeaconsofts.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer hover:underline"
            >
              <strong>EBEACONSOFTS SMC PVT LTD</strong>
            </a>
          </div>
        </div>
      </div>

      {/* RIGHT SIDE (Login Form) */}
      <div className="flex w-full md:w-1/2 items-center justify-center p-6">
        <div className="w-full max-w-md bg-white/90 backdrop-blur-lg rounded-2xl shadow-xl p-8">
          <h2
            className="text-2xl font-bold mb-6 text-center"
            style={{
              color: globalStyle.curveDarkColor,
              fontFamily: globalStyle.fontFamilyHeading,
            }}
          >
            Sign in to your account
          </h2>

          {/* Email */}
          <label className="text-sm font-medium text-gray-700">
            Email Address
          </label>
          <input
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="you@example.com"
            className={`mt-1 w-full px-3 py-2 rounded-md border ${
              error ? "border-red-500" : "border-gray-300"
            } focus:outline-none focus:ring-2 focus:ring-[#3A80FB] transition`}
          />
          {helperText && (
            <p className="text-red-500 text-xs mt-1">{helperText}</p>
          )}

          {/* Password */}
          <label className="text-sm font-medium text-gray-700 mt-4 block">
            Password
          </label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="mt-1 w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#3A80FB]"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-2.5 text-gray-500 text-sm"
            >
              {showPassword ? "Hide" : "Show"}
            </button>
            <div className="flex justify-end mt-1">
              <button
                type="button"
                onClick={() => navigate("/forgot-password")}
                className="text-sm text-[#3A80FB] hover:underline"
              >
                Forgot Password?
              </button>
            </div>
          </div>
          {/* Login Button */}
          <button
            onClick={handleLogin}
            disabled={!email || !password || error || isLoginUser}
            className="w-full mt-6 py-2 rounded-md text-white font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            style={{ background: globalStyle.buttonColor }}
          >
            {isLoginUser ? (
              <span className="flex justify-center items-center gap-2">
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="white"
                    strokeWidth="4"
                    fill="none"
                  />
                </svg>
                Signing in...
              </span>
            ) : (
              "Sign In"
            )}
          </button>

          {/* Contact */}
          <div className="text-center mt-6 text-sm text-gray-500">
            Need access?{" "}
            <a
              rel="noreferrer"
              href="tel:+923054243913"
              className="text-[#3A80FB] font-medium cursor-pointer hover:underline"
            >
              Contact Us
            </a>
          </div>

          {/* Footer */}
          <div className="text-center text-xs text-gray-400 mt-6">
            © {new Date().getFullYear()}{" "}
            <a
              href="https://ebeaconsofts.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer hover:underline"
            >
              EBEACONSOFTS SMC PVT LTD
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
